import axios, { AxiosError } from 'axios';
import { SUPPORTED_CURRENCIES_MAP, SupportedCurrencies, ValidationWithSubErrors } from 'types/common';

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getHttpStatus = (e: any): number | undefined => {
    return e?.response?.status ?? e?.status;
};

export const getCurrencySymbol = (currency: string | undefined): string => {
    if (!currency) return '';

    if (currency.toUpperCase() === 'EUR') {
        return '€';
    }

    if (currency.toUpperCase() === 'GBP') {
        return '£';
    }

    if (currency.toUpperCase() === 'USD') {
        return '$';
    }

    return '';
};

export const isBeValidationError = (error: unknown): error is AxiosError<ValidationWithSubErrors> => {
    return (
        axios.isAxiosError(error) &&
        typeof error.response?.data === 'object' &&
        error.response?.data !== null &&
        'subErrors' in error.response.data
    );
};

// Requests made with `responseType: 'blob'` deliver error bodies as an opaque Blob instead of
// parsed JSON, so isBeValidationError can't see `subErrors` on them. This unwraps the Blob back
// into a plain object (mutating response.data in place) when it's actually a JSON error body.
export const resolveAxiosBlobError = async (error: unknown): Promise<unknown> => {
    if (!axios.isAxiosError(error) || !(error.response?.data instanceof Blob)) {
        return error;
    }

    try {
        error.response.data = JSON.parse(await error.response.data.text());
    } catch {
        // Not a JSON body - leave the error untouched.
    }

    return error;
};

// TODO: For now we always show EURO as a currency
// We are planning to allow configuring the currency per tenant and then this handler can be updated
export const getCurrencyData = (
    currency: SupportedCurrencies = 'EUR'
): {
    currencyCode: string;
    currencySymbol: string;
} => {
    const currencyData = SUPPORTED_CURRENCIES_MAP[currency];

    return {
        currencyCode: currencyData.code,
        currencySymbol: currencyData.symbol,
    };
};
